import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/views/index'),
      children: [
        {
          path: '',
          name: 'index',
          component: () => import('@/views/main.vue'),
        },
        {
          path: '/feedback',
          name: 'feedback',
          component: () => import('@/views/feedback'),
        }
      ]
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js